import React, { useEffect, useState } from "react";
import { Chart, Series, CommonSeriesSettings, Legend, Export} from "devextreme-react/chart";
import { Button } from "devextreme-react/button";
import DateFilter from "../../date-filter/DateFilter";
import DateRange from "../../date-range/DateRange";
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import STATISTICS_API from "api/statisticsApi";
import { useFetch } from "@hooks/useStatApi";
import { Tooltip } from "devextreme-react/chart";



function CustomBarWidth({ batchNo, type = {} , batchId = null}) {
    const today = dayjs().startOf('day');
    const oneWeekAgo = today.subtract(1, 'week');
    let supplierId = localStorage.getItem('supplierId');
    const shouldFetch = supplierId !== null; // will be null initially, but maybe undefined is also meaningful

  const [dateRange, setDateRange] = useState(`${oneWeekAgo.format('YYYY-MM-DD')} - ${today.format('YYYY-MM-DD')}`);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const batchID = useSelector((state) => state.overview.batchId);
  const handleRedirect = () => {
    const url = `${window.location.origin}/quality/fillet/quality/${supplierId}`;
    window.open(url, "_blank"); // Opens in a new tab with correct URL
  };

    const [startDate, endDate] = dateRange
      ? dateRange.split(' - ').map(date => dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
      : [null, null];
  const params = {

    startDate,
    endDate,
    supplierId,
  };

  const { data: quality, loading: isQualityLoading, refetch } = useFetch(
    "fetchQuality",
    STATISTICS_API.quality,
    shouldFetch ? params : null

  );

  const { data: qualityBatch, loading: isQualityBatchLoading } = useFetch(
    "fetchQuality",
    STATISTICS_API.getQualityInfoByBatch,
    batchNo ? { batchNo, startDate, endDate } : null

  );

  const transformedData = (qualityBatch?.data?.length > 0 ? qualityBatch.data : quality?.data)?.map(item => ({
    category: item.productSize,
    grownSkinWounds: item.grownSkinWounds.count,
    grownSkinWoundsPercentage: item.grownSkinWounds.percentage,
    rawLargestBloodSpot: item.rawLargestBloodSpot.count,
    rawLargestBloodSpotpercentage: item.rawLargestBloodSpot.percentage,
    rawLargestGaping: item.rawLargestGaping.count,
    rawLargestGapingPercentage: item.rawLargestGaping.percentage,
    rawLargestMelaninSpot: item.rawLargestMelaninSpot.count,
    rawLargestMelaninSpotPercentage: item.rawLargestMelaninSpot.percentage,
    redSkinWounds: item.redSkinWounds.count,
    redSkinWoundsPercentage: item.redSkinWounds.percentage,
    whiteSkinWounds: item.whiteSkinWounds.count,
    whiteSkinWoundsPercentage: item.whiteSkinWounds.percentage,
  }));
  
  const handleQuickFilter = (filter) => {
    setSelectedFilter(filter);
    const today = dayjs().startOf('day'); // Ensure it starts from today

    let fromDate = today.format('YYYY-MM-DD'); // Default to today
    switch (filter) {
      case '1W': fromDate = today.subtract(1, 'week').format('YYYY-MM-DD'); break;
      case '3W': fromDate = today.subtract(3, 'week').format('YYYY-MM-DD'); break;
      case '3M': fromDate = today.subtract(3, 'month').format('YYYY-MM-DD'); break;
      case '1Y': fromDate = today.subtract(1, 'year').format('YYYY-MM-DD'); break;
      default: break;
    }

    console.log(`Filter: ${filter}, From: ${fromDate}, To: ${today.format('YYYY-MM-DD')}`);
    setDateRange(`${fromDate} - ${today.format('YYYY-MM-DD')}`);
  };

  useEffect(() => {
    if (dateRange) refetch();
  }, [dateRange, refetch]);

  return (
    <React.Fragment>
      {/* Header with Title, Date Range Picker, and Export Button */}
      <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4 mb-4">
        <div>
          <p className="mb-0 text-xl font-medium">Quality</p>
        </div>
        <div>
          <DateFilter onFilterChange={handleQuickFilter} selectedFilter={selectedFilter} />
        </div>
        <div className="flex justify-between items-center">
          <DateRange onDateChange={setDateRange} dateRange={dateRange} />
          {
            type != "full" ?

              <Button onClick={handleRedirect} className="ms-2" icon="fullscreen" />
              : null}

        </div>
      </div>

      {/* Chart Component */}

      {
        transformedData?.length > 0 ? (
      <Chart id="chart" palette={["#6DD3FF", "#FEC84B", "#32D583"]} dataSource={transformedData || []} // Ensure it's never undefined
      >
        <CommonSeriesSettings argumentField="category" type="bar" barPadding={0.7} />
        <Series valueField="grownSkinWounds" name="Grown Skin Wounds" />
        <Series valueField="rawLargestBloodSpot" name="Raw Largest Blood Spot" />
        <Series valueField="rawLargestGaping" name="Raw Largest Gaping" />
        <Series valueField="rawLargestMelaninSpot" name="Raw Largest Melanin Spot" />
        <Series valueField="redSkinWounds" name="Red Skin Wounds" />
        <Series valueField="whiteSkinWounds" name="White Skin Wounds" />
        <Legend verticalAlignment="bottom" horizontalAlignment="center" />
        <Export enabled={false} />
        <Tooltip
  enabled={true}
  customizeTooltip={(arg) => {
    const { seriesName, valueText, point } = arg;
    const data = point?.data || {};
    let percentage = null;

    switch (seriesName) {
      case 'Grown Skin Wounds':
        percentage = data.grownSkinWoundsPercentage;
        break;
      case 'Raw Largest Blood Spot':
        percentage = data.rawLargestBloodSpotpercentage;
        break;
      case 'Raw Largest Gaping':
        percentage = data.rawLargestGapingPercentage;
        break;
      case 'Raw Largest Melanin Spot':
        percentage = data.rawLargestMelaninSpotPercentage;
        break;
      case 'Red Skin Wounds':
        percentage = data.redSkinWoundsPercentage;
        break;
      case 'White Skin Wounds':
        percentage = data.whiteSkinWoundsPercentage;
        break;
      default:
        percentage = null;
    }

    return {
      text: `Count: ${valueText}\nPercentage: ${percentage !== null ? percentage + '%' : 'N/A'}`,
    };
  }}
/>
        <Legend
  verticalAlignment="bottom"
  horizontalAlignment="center"
  itemTextPosition="right"
  rowCount={1}
  columnCount={6}
/>

  <Export
          enabled={true}
          formats={['PNG', 'PDF', 'SVG']}
          fileName="quality-chart"
        />
      </Chart>
  ) : (
    <div className="flex justify-center items-center h-96">
    <p className="no-data-text">No Data Found</p>
  </div>
  )
} 
    </React.Fragment>
  );
}

export default CustomBarWidth;
